<section class="trazabilidad container py-4">
  <h2>Trazabilidad del expediente {{ expedienteId }}</h2>
  <div *ngIf="expediente" class="card mb-4 shadow-sm border-0 bg-light">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <h5 class="card-title text-primary mb-3">Expediente #{{ expediente.exp_id }}</h5>
          <p class="mb-1"><strong>Funcionario:</strong> {{ expediente.exp_nombre_fun }} {{
            expediente.exp_apellido_paterno_fun }} {{ expediente.exp_apellido_materno_fun }}</p>
          <p class="mb-1"><strong>RUT:</strong> {{ expediente.exp_rut_fun }}</p>
        </div>
        <div class="col-md-6">
          <p class="mb-1"><strong>Estado Actual:</strong> <span class="badge badge-primary">{{ expediente.eex_nombre
              }}</span></p>
          <p class="mb-1"><strong>Fecha Ingreso:</strong> {{ expediente.exp_fecha_ingreso | date:'dd/MM/yyyy HH:mm' }}
          </p>
          <p class="mb-0" *ngIf="expediente.exp_observaciones"><strong>Observaciones:</strong> {{
            expediente.exp_observaciones }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex mb-3 align-items-center traz-controls">
    <label class="mr-2">Filtrar por tipo:</label>
    <select class="form-control w-auto mr-3" [(ngModel)]="filtroTipo" (change)="applyFilter()">
      <option value="">-- Todos --</option>
      <option *ngFor="let t of tipos" [value]="t">{{ t }}</option>
    </select>

    <div class="ml-auto d-flex flex-wrap">
      <button class="btn btn-outline-secondary btn-sm mr-2" (click)="exportCSV()">Exportar CSV</button>
      <button class="btn btn-outline-secondary btn-sm" (click)="exportPDF()">Exportar PDF</button>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
    <p class="mt-2 text-muted">Cargando trazabilidad...</p>
  </div>

  <div *ngIf="!isLoading && filtered.length > 0; else noEvents">
    <div class="timeline">
      <!-- Flecha indicadora de 'Más reciente' arriba -->
      <div class="timeline-arrow-top"></div>

      <div class="timeline-item" *ngFor="let e of filtered; let isFirst = first" [class.current]="isFirst">
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <div class="timeline-header d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center w-100">
              <span class="timeline-title font-weight-bold text-dark">
                <ng-container *ngIf="e.estadoAnterior && e.estadoNuevo; else descTitle">
                  {{ e.estadoAnterior }} &rarr; {{ e.estadoNuevo }}
                </ng-container>
                <ng-template #descTitle>{{ e.descripcion }}</ng-template>
              </span>
              <span class="timeline-date small text-muted text-nowrap ml-2">{{ e.fecha | date:'dd/MM/yyyy HH:mm'
                }}</span>
            </div>
            <small class="timeline-subtitle text-uppercase text-primary font-weight-bold mt-1">{{ e.tipo }}</small>
          </div>

          <div class="timeline-body mt-2">
            <div *ngIf="isFirst" class="mb-2">
              <span class="badge badge-success">Evento Más Reciente (Estado Actual)</span>
            </div>

            <!-- Show description body only if we used State Change as title -->
            <p class="mb-1" *ngIf="e.estadoAnterior && e.estadoNuevo">{{ e.descripcion }}</p>

            <small class="text-muted d-block">Usuario: {{ e.usuario }}</small>
            <div *ngIf="e.detallesExtra" class="mt-1 small text-info">{{ e.detallesExtra }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noEvents>
    <div *ngIf="!isLoading" class="alert alert-info mt-4">
      No se encontraron eventos de trazabilidad para este expediente.
    </div>
  </ng-template>
</section>